import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { ForeignNews } from "../home/templates";
import {
  Button,
  NewsCard,
  NewsGroup,
  PageNavigation,
  Pagination,
} from "../../components";
import { getCategoryById } from "../CreateNewItem/CreateNewCategory/service/category.service";
import { getLanguage } from "../../utils/environment";
import { useLocation } from "react-router-dom";
import { getNewsByCategory } from "../news/service/news.service";
import HotNews from "../home/templates/hotNews";
import { Helmet } from "react-helmet";
import { CategoryRightTopAdd } from "../templates/advertiesments";
import TopNews from "../templates/topNews";
import CategoryMainNews from "../home/templates/categoryMainNews";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import WidgetNewsCard from "../templates/widgetNewsCard";

const lan = getLanguage();
const pageCount = process.env.REACT_APP_MAIN_P_COUNT;

const Index = ({ onChangeCategory, onChangeTag, props }) => {
  const location = useLocation();
  const history = useHistory();
  const [menu, setMenu] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [mainNews, setMainNews] = useState([]);
  const [category, setCategory] = React.useState("");
  const [pageNo, setPageNo] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = React.useState(false);
  const [isTrending, setIsTrending] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    let param = location.pathname.split("/");
    // console.log({ param });
    let newCategory = param[1];
    if (mainNews?.length < 0 || newCategory !== category) {
      setIsLoading(true);
      fetchPageData(newCategory);
    }
  }, [location.pathname]);

  const onChangeMenu = (category) => {
    onChangeCategory(category);
  };
  const handleChangeTag = (tag) => {
    onChangeTag(tag);
  };

  async function fetchPageData(category) {
    let param = window.location.pathname;
    param = param.split("/");
    // console.log({ param });
    if ((param && param[1]) || category) {
      const categoryId = param[1];
      // console.log({ categoryId });
      setCategory(categoryId || category);
      try {
        let res = await getCategoryById(categoryId || category);
        // console.log(res);
        if (res?.data) {
          setMenu(res?.data);

          let response = await getNewsByCategory(categoryId, 9, 1);
          // console.log("response", response);
          if (response?.data?.news?.length > 0) {
            setMainNews(response?.data?.news);
            setNews(response?.data?.news?.slice(0, 5));
            setPageCount(response?.data?.count);
            setPageNo(1);
            setHasMore(response.data.news.length < response.data.count);
          } else {
            setMainNews([]);
            setNews([]);
            setHasMore(false);
          }
        } else {
          setMainNews([]);
          setNews([]);
        }
        setIsLoading(false);
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
      }
    }
  }

  const loadMoreNews = async (currentPage) => {
    try {
      const nextPage = currentPage + 1;
      const response = await getNewsByCategory(category, 9, nextPage);
      if (response?.data?.news?.length > 0) {
        setMainNews((prev) => [...prev, ...response.data.news]);
        setPageNo(nextPage);

        //  Check if more news available
        if (
          mainNews.length + response.data.news.length >=
          response.data.count
        ) {
          setHasMore(false);
        }
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setLoadingMore(false);
    }
  };

  const onChangePage = async (pageNumber, size) => {
    console.log("onChangePage", pageNumber, size);
    // setIsLoading(true);
    try {
      if (pageNumber !== pageNo || size !== pageSize) {
        let response = await getNewsByCategory(
          category,
          size || pageSize,
          pageNumber
        );
        // console.log("response next::", response);
        if (response?.data?.news?.length > 0) {
          setNews(response?.data?.news);
          setPageNo(pageNumber);
          setPageSize(size || pageSize);
          // window.scrollTo(0, 0);
        }
      }

      // setIsLoading(false);
    } catch (error) {
      console.log({ error });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    let param = location.pathname.split("/");
    console.log({ param });
    let newCategory = param[1];
    if (news?.length < 0) {
      setIsLoading(true);
      fetchPageData(newCategory);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {menu?.name?.[lan] || "Hope of a New Era – News by Category"}
        </title>
        <meta
          name="description"
          content={`Read the latest news on ${
            menu?.name?.[lan] || "various topics"
          } from Hope of a New Era.`}
        />
        <meta
          name="keywords"
          content={`Sri Lanka news, ${
            menu?.name?.[lan] || ""
          }, Hope of a New Era`}
        />
        <meta name="author" content="Hope of a New Era" />
        <meta
          property="og:title"
          content={menu?.name?.[lan] || "Hope of a New Era"}
        />
        <meta
          property="og:description"
          content={`Latest news articles under ${
            menu?.name?.[lan] || "various topics"
          }`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={menu?.name?.[lan] || "Hope of a New Era"}
        />
        <meta
          name="twitter:description"
          content={`Explore current stories about ${
            menu?.name?.[lan] || "Sri Lanka topics"
          }`}
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <PageNavigation
        data={{
          main: "Home",
          page: " category > " + menu?.name?.[lan],
        }}
        onClick={() => history.push("/")}
      />

      <div className={`hot-news-wrapper mt-2`}>
        <>
          <div className={"hw__special-news-group"}>
            {!isLoading && (
              <NewsGroup
                data={{
                  titleName: menu?.name?.[lan] || "",
                  // linkName:
                  //   lan === "en"
                  //     ? "More " + menu?.name?.[lan]
                  //     : "තවත් " + menu?.name?.[lan],
                }}
                onClickViewNews={() => {
                  // props.history.push("/" + categoryId);
                  // props.setMenuName(categoryId);
                  props.history.push("/" + menu?.category_id);
                  onChangeMenu();
                }}
              >
                {isLoading && (
                  <NewsCard data={{ type: "loading", isBorder: true }} />
                )}
                {!isLoading &&
                  // news.map((item, index) => {
                  mainNews.slice(0, 1).map((item, index) => {
                    // Check if the item has updates
                    const hasUpdates =
                      Array.isArray(item.updates) && item.updates.length > 0;

                    // If updates exist, use the latest update (or modify as needed)
                    const displayItem = hasUpdates
                      ? { ...item, ...item.updates[item.updates.length - 1] }
                      : item;

                    return (
                      <React.Fragment key={index}>
                        <NewsCard
                          key={index}
                          data={{
                            type: "extralarge",
                            isBorder: true,
                            isUpdate: hasUpdates,
                          }}
                          item={displayItem}
                          onClick={() => {
                            if (displayItem?.keywords?.[lan]) {
                              history.push(
                                `/${displayItem?.keywords?.[lan]}/${displayItem?.news_id}`
                              );
                            } else {
                              const generatedSlug = displayItem?.title?.[lan]
                                ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                                ?.replace(/\//g, "")
                                ?.replace(/\s*-\s*/g, " ")
                                ?.trim()
                                .split(/\s+/)
                                .slice(0, 5)
                                .join("-")
                                .replace(/-+/g, "-");
                              history.push(
                                `/${generatedSlug}/${displayItem?.news_id}`
                              );
                            }
                          }}
                        />
                      </React.Fragment>
                    );
                  })}

                <div className={"more-hot-news"}>
                  {!isLoading &&
                    // except  first item, show the rest of the items
                    mainNews.slice(1, mainNews?.length).map((item, index) => {
                      // news.map((item, index) => {
                      // Check if the item has updates
                      const hasUpdates =
                        Array.isArray(item.updates) && item.updates.length > 0;

                      // If updates exist, use the latest update (or modify as needed)
                      const displayItem = hasUpdates
                        ? { ...item, ...item.updates[item.updates.length - 1] }
                        : item;

                      return (
                        <React.Fragment key={index}>
                          <NewsCard
                            key={index}
                            data={{
                              type: "extrasmall",
                              isBorder: false,
                              isUpdate: hasUpdates,
                            }}
                            item={displayItem}
                            onClick={() => {
                              const generatedSlug = displayItem?.title?.[lan]
                                ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                                ?.replace(/\//g, "")
                                ?.replace(/\s*-\s*/g, " ")
                                ?.trim()
                                .split(/\s+/)
                                .slice(0, 5)
                                .join("-")
                                .replace(/-+/g, "-");
                              history.push(
                                `/${generatedSlug}/${displayItem?.news_id}`
                              );
                            }}
                            onChangeTag={handleChangeTag}
                          />
                        </React.Fragment>
                      );
                    })}
                </div>
                {isLoading && (
                  <NewsCard data={{ type: "loading", isBorder: true }} />
                )}
                {hasMore && (
                  <div className="loading-more">
                    {/* Loading more news... */}
                    <Button
                      data={{
                        btnName: loadingMore ? "Loading..." : "Load More News",
                        buttonType: "primary ",
                        buttonSize: "xs",
                        isLoading: isLoading,
                      }}
                      onClick={async (e) => {
                        e.preventDefault();
                        if (!loadingMore && hasMore) {
                          setLoadingMore(true);
                          await loadMoreNews(pageNo);
                        }
                      }}
                    />
                  </div>
                )}
                {!hasMore && (
                  <div className="loading-more">No more news available.</div>
                )}
              </NewsGroup>
            )}
            <TopNews active={isLoading} />
            {/* <WidgetNewsCard /> */}
          </div>

          <div className={"hw__special-news-group"}>
            <CategoryRightTopAdd />
            <ForeignNews setMenuName={onChangeMenu} />
          </div>
        </>
        {isLoading && <div className="hw__special-news-group">Loading... </div>}
      </div>
    </>
  );
};
export default withRouter(Index);
